module.exports = __webpack_public_path__ + "static/media/logo-extendeal.0e28b147.svg";